module.exports = __webpack_public_path__ + "images/onthemove_smalld685f63703d9336a285bceff2930d382.png";